import React from 'react';
import styled from 'styled-components';
import DataTable from 'react-data-table-component';
import { getRoomsAllocations } from '../../UserFunctions';

const Styles = styled.div`
    .overlay {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

 
const columns = [
  {
    name: 'Date',
    selector: 'date',
    sortable: true,
  },
  {
    name: 'Room ID',
    selector: 'room_id',
    sortable: true,
  }
];
 
export class AllocatedRooms extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rooms: []
        }
        this.onChange = this.onChange.bind(this);
        // this.onSubmit = this.onSubmit.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    onChange(e) {
      this.setState({[e.target.name]: e.target.value});
  }


    updateState = state => {
        this.setState({ selectedRows: state.selectedRows });
      }

    componentDidMount() {
      
      getRoomsAllocations({ward_id: '2'}).then(res => {
        this.setState({rooms: res.data})
      }).catch(err => {
        console.log(err);
      })
        
    }

  render() {

    return (
      <Styles>
        <DataTable
          title="Rooms Distribution:"
          columns={columns}
          highlightOnHover
          data={this.state.rooms}
          selectableRows
          dense
          onSelectedRowsChange={this.updateState}
        />
      </Styles>
    )
  }
};
 
export default AllocatedRooms
